import { render, staticRenderFns } from "./activityConfig.vue?vue&type=template&id=3ca7fe08&scoped=true&"
import script from "./activityConfig.vue?vue&type=script&lang=js&"
export * from "./activityConfig.vue?vue&type=script&lang=js&"
import style0 from "./activityConfig.vue?vue&type=style&index=0&id=3ca7fe08&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca7fe08",
  null
  
)

export default component.exports